import { render } from "./AddEditForm.vue?vue&type=template&id=9c0a90f2"
import script from "./AddEditForm.vue?vue&type=script&lang=js"
export * from "./AddEditForm.vue?vue&type=script&lang=js"

import "./AddEditForm.vue?vue&type=style&index=0&id=9c0a90f2&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__